import { render, staticRenderFns } from "./add-pro.vue?vue&type=template&id=31a81902&scoped=true"
import script from "./add-pro.vue?vue&type=script&lang=js"
export * from "./add-pro.vue?vue&type=script&lang=js"
import style0 from "./add-pro.vue?vue&type=style&index=0&id=31a81902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a81902",
  null
  
)

export default component.exports